<template>
  <div id="db-collapse">
    <Row>
      <Layout>
        <Content :style="{minHeight: '280px'}">
          <Layout>
            <Sider hide-trigger :style="{background: '#fff'}">
              <Spin fix v-show="getDbListLoading">
                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                <div>正在获取数据库列表</div>
              </Spin>
              <Collapse :value="openDb" simple class="cu-content db-list">
                <Panel v-for="item in databaseList" :name="item" :key="item" class="db-list-panel">
                  <Dropdown trigger="contextMenu" style="margin-right: 5px; float: left; overflow: hidden; text-overflow:ellipsis; white-space: nowrap; width: 140px;" @on-click="v=>{ dbClickTools(v, item)}" transfer>
                    <span style="">
                      <span><font-awesome-icon icon="database" :style="{color: openDb.indexOf(item) > -1 ? '#2d8cf0' : ''}" /></span>
                      <Tooltip max-width="140" :content="item" placement="bottom-start" style="padding-left: 5px">
                        <span>{{ item }}</span>
                      </Tooltip>
                    </span>
                    <!--<DropdownMenu slot="list">-->
                      <!--<DropdownItem name="edit">编辑</DropdownItem>-->
                      <!--<DropdownItem name="delete" style="color: red">删除</DropdownItem>-->
                    <!--</DropdownMenu>-->
                  </Dropdown>
                  <div slot="content">
                    <div v-for="dbMenuItem in dbMenu" :key="dbMenuItem.value" style="height: 30px">
                      <Dropdown trigger="contextMenu" style="float: right; padding-right: 5px; overflow: hidden; text-overflow:ellipsis; white-space:nowrap; display: inline-block; width: 200px; padding-left: 20px" @on-click="v=>{ dbMenuClickTools(v, item)}" transfer>
                        <a class="tmp-item tmp-item-general" href="javascript:void(0)" v-on:click="dbMenuClickTools(dbMenuItem.value, item)">
                          <span>
                            <span><font-awesome-icon :icon="dbMenuItem.icon"/> </span>
                            <span style="padding-left: 5px">{{ dbMenuItem.name }}</span>
                          </span>
                        </a>
                        <DropdownMenu slot="list" v-if="dbMenuItem.value === 'table'">
                          <DropdownItem name="createTable">新建表</DropdownItem>
                        </DropdownMenu>
                        <DropdownMenu slot="list" v-if="dbMenuItem.value === 'view'">
                          <DropdownItem name="createView">新建视图</DropdownItem>
                        </DropdownMenu>
                        <DropdownMenu slot="list" v-if="dbMenuItem.value === 'sql'">
                          <DropdownItem name="sql">新建查询</DropdownItem>
                        </DropdownMenu>
                        <DropdownMenu slot="list" v-if="dbMenuItem.value === 'func'">
                          <DropdownItem name="createFunc">新建函数</DropdownItem>
                        </DropdownMenu>
                        <DropdownMenu slot="list" v-if="dbMenuItem.value === 'event'">
                          <DropdownItem name="createEvent">新建事件</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </Sider>
            <Content :style="{minHeight: '280px', background: '#fff'}">
              <Tabs type="card" closable @on-tab-remove="handleTabRemove" :animated="false" size="small"
                    v-model="aceTab" style="padding-left: 5px;" name="contentTab">
                <TabPane v-for="tab in tabList" :key="'table_' + tab.id" :label="tab.label" :name="tab.id + ''" tab="contentTab">
                  <div class="cu-content right-component">
                    <component :is="tab.view" :callbackdata="tab" v-on:callBack="componentCallBack"></component>
                  </div>
                </TabPane>
              </Tabs>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Row>
  </div>
</template>

<script>
import { showDatabaseList } from '@/api/mysql'
import execSQL from './components/execSQL'
import dbTableList from './components/dbTableList'
import dbTableData from './components/dbTableData'
import dbTableEdit from './components/dbTableEdit'
import dbViewList from './components/dbViewList'
import dbViewEdit from './components/dbViewEdit'
import dbFuncList from './components/dbFuncList'
import dbFuncEdit from './components/dbFuncEdit'
import dbEventList from './components/dbEventList'
import dbEventEdit from './components/dbEventEdit'

export default {
  name: 'sql',
  components: {
    execSQL,
    dbTableList,
    dbTableData,
    dbTableEdit,
    dbViewList,
    dbViewEdit,
    dbFuncList,
    dbFuncEdit,
    dbEventList,
    dbEventEdit
  },
  data () {
    return {
      databaseList: [],
      tabList: [],
      aceTab: '',
      openDb: [],
      dbMenu: [
        {name: '表', value: 'table', icon: 'table', dbTableOpenCollapse: [], tables: []},
        {name: '视图', value: 'view', icon: 'glasses'},
        {name: '函数', value: 'func', icon: 'superscript'},
        {name: '事件', value: 'event', icon: 'clock'},
        {name: '查询', value: 'sql', icon: 'object-ungroup'}
        // {name: '报表', value: 'report', icon: 'file-alt'},
        // {name: '备份', value: 'backup', icon: 'copy'}
      ],
      getDbListLoading: false
    }
  },
  created: function () {
    this.getDatabases()
  },
  mounted: function () {
    this.dbMenuClickTools('sql', '')
  },
  methods: {
    // 展开数据库
    expandTree (group, name) {
      name.expand = !name.expand
    },
    // 随机生成数
    iRandom () {
      return (new Date()).getTime() + Math.round(Math.random() * 10000) + ''
    },
    // 移除标签
    handleTabRemove (name) {
      for (let i in this.tabList) {
        if (this.tabList[i].id === name) {
          this.tabList.splice(i, 1)
          break
        }
      }
    },
    // 获取数据库列表
    getDatabases () {
      let params = {
        id: this.$route.query.id
      }
      this.databaseList = []
      this.getDbListLoading = true
      showDatabaseList(params).then(res => {
        this.getDbListLoading = false
        if (res.status === 200) {
          this.databaseList = res.data.results
        } else {
          this.$Notice.error({
            title: '获取数据库列表失败！'
          })
        }
      }).catch(res => {
        this.getDbListLoading = false
        this.$Notice.error({
          title: '获取数据库列表失败！'
        })
      })
    },
    // 数据库右键菜单栏工具
    dbClickTools () {

    },
    // 数据库展开菜单栏工具
    dbMenuClickTools (type, db, kwarg = null) {
      let myRandom = this.iRandom()
      let data = null
      switch (type) {
        // SQL查询
        case 'sql':
          data = {
            label: db ? db + ' - SQL查询' : 'SQL查询',
            view: 'execSQL',
            ref: 'execSQL_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 表对象
        case 'table':
          data = {
            label: db + ' - 表',
            view: 'dbTableList',
            ref: 'dbTableList_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 表数据
        case 'tableData':
          data = {
            label: kwarg + '@' + db + ' - 表',
            view: 'dbTableData',
            ref: 'dbTableData_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id,
            sql: 'SELECT * FROM ' + kwarg,
            table: kwarg
          }
          break
        // 创建表
        case 'createTable':
          data = {
            label: db + ' - 新建表',
            view: 'dbTableEdit',
            ref: 'dbTableEdit_' + myRandom,
            id: myRandom,
            databaseList: this.databaseList,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 修改表
        case 'modifyTable':
          data = {
            label: kwarg + '@' + db + ' - 编辑表',
            view: 'dbTableEdit',
            ref: 'dbTableEdit_' + myRandom,
            id: myRandom,
            databaseList: this.databaseList,
            db: db,
            instance_id: this.$route.query.id,
            table: kwarg
          }
          break
        // 视图对象
        case 'view':
          data = {
            label: db + ' - 视图',
            view: 'dbViewList',
            ref: 'dbViewList_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 视图数据
        case 'viewData':
          data = {
            label: kwarg + '@' + db + ' - 视图',
            view: 'dbTableData',
            ref: 'dbTableData_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id,
            sql: 'SELECT * FROM ' + kwarg,
            viewName: kwarg
          }
          break
        // 创建视图
        case 'createView':
          data = {
            label: db + ' - 新建视图',
            view: 'dbViewEdit',
            ref: 'dbViewEdit_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 编辑视图
        case 'modifyView':
          data = {
            label: kwarg + '@' + db + ' - 编辑视图',
            view: 'dbViewEdit',
            ref: 'dbViewEdit_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id,
            viewName: kwarg
          }
          break
        // 函数对象
        case 'func':
          data = {
            label: db + ' - 函数',
            view: 'dbFuncList',
            ref: 'dbFuncList_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 创建函数
        case 'createFunc':
          data = {
            label: db + ' - 新建函数',
            view: 'dbFuncEdit',
            ref: 'dbFuncEdit_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 编辑函数
        case 'modifyFunc':
          data = {
            label: kwarg + '@' + db + ' - 编辑函数',
            view: 'dbFuncEdit',
            ref: 'dbFuncEdit_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id,
            func: kwarg
          }
          break
        // 事件对象
        case 'event':
          data = {
            label: db + ' - 事件',
            view: 'dbEventList',
            ref: 'dbEventList_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 创建事件
        case 'createEvent':
          data = {
            label: db + ' - 新建事件',
            view: 'dbEventEdit',
            ref: 'dbEventEdit_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id
          }
          break
        // 编辑事件
        case 'modifyEvent':
          data = {
            label: kwarg + '@' + db + ' - 编辑事件',
            view: 'dbEventEdit',
            ref: 'dbEventEdit_' + myRandom,
            id: myRandom,
            db: db,
            instance_id: this.$route.query.id,
            event: kwarg
          }
          break
      }
      if (data) {
        this.tabList.push(data)
        this.aceTab = data.id
      }
    },
    // 回调
    componentCallBack (type, data) {
      switch (type) {
        // 表
        case 'createTable':
          this.dbMenuClickTools('createTable', data.db)
          break
        case 'openTable':
          this.dbMenuClickTools('tableData', data.db, data.table)
          break
        case 'createTableSuccess':
          this.dbMenuClickTools('modifyTable', data.db, data.table)
          this.handleTabRemove(data.tab_id)
          break
        case 'modifyTable':
          this.dbMenuClickTools('modifyTable', data.db, data.table)
          break
        // 视图
        case 'createView':
          this.dbMenuClickTools('createView', data.db)
          break
        case 'openView':
          this.dbMenuClickTools('viewData', data.db, data.viewName)
          break
        case 'createViewSuccess':
          this.dbMenuClickTools('modifyView', data.db, data.viewName)
          this.handleTabRemove(data.tab_id)
          break
        case 'modifyView':
          this.dbMenuClickTools('modifyView', data.db, data.viewName)
          break
        // 函数
        case 'createFunc':
          this.dbMenuClickTools('createFunc', data.db)
          break
        case 'openFunc':
          this.dbMenuClickTools('funcData', data.db, data.func)
          break
        case 'createFuncSuccess':
          this.dbMenuClickTools('modifyFunc', data.db, data.func)
          this.handleTabRemove(data.tab_id)
          break
        case 'modifyFunc':
          this.dbMenuClickTools('modifyFunc', data.db, data.func)
          break
        // 事件
        case 'createEvent':
          this.dbMenuClickTools('createEvent', data.db)
          break
        case 'openEvent':
          this.dbMenuClickTools('eventData', data.db, data.event)
          break
        case 'createEventSuccess':
          this.dbMenuClickTools('modifyEvent', data.db, data.event)
          this.handleTabRemove(data.tab_id)
          break
        case 'modifyEvent':
          this.dbMenuClickTools('modifyEvent', data.db, data.event)
          break
      }
    }
  }
}
</script>

<style lang='scss'>
  #db-collapse .ivu-collapse-content-box, #db-collapse .ivu-collapse-content {
    padding: 0;
  }
  #db-collapse .tmp-item {
    line-height: 30px;
    color: #515a6e;
    height: 30px;
    padding: 0 16px;
    display: block;
  }
  #db-collapse .tmp-item-table {
    float: left;
  }
  #db-collapse .tmp-item-active {
    color: #2d8cf0;
  }
  #db-collapse .tmp-item:hover {
    color: #2d8cf0;
  }
  #db-collapse .tmp-item:visited {
    color: #2d8cf0;
  }
  #db-collapse .db-list-panel:hover {
    background-color: rgb(243, 243, 243);
  }
  #db-collapse .db-list-panel:visited {
    background-color: rgb(243, 243, 243);
  }
  #db-collapse .cu-content {
    padding: 0;
    overflow-y: auto;
    padding-bottom: 5px;
    border: 0;
  }
  #db-collapse .cu-content::-webkit-scrollbar {
    width: 5px;
  }
  #db-collapse .cu-content::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  #db-collapse .cu-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  #db-collapse .db-list {
    max-height: 720px;
  }
  #db-collapse .right-component {
    padding-right: 5px;
    max-height: 710px;
  }
  #db-collapse .ivu-collapse-item {
    border: 0 !important;
  }
  #db-collapse .ivu-collapse-item .ivu-collapse-header {
    height: 30px;
    line-height: 30px;
  }
  #db-collapse {
    border: 0;
  }
  #db-collapse .table-collapse {
    border: 0;
    .ivu-collapse-header {
      padding-left: 0;
    }
  }
  #db-collapse .ivu-tabs-bar {
    margin-bottom: 10px;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
</style>
